import React from 'react';
import {Button, Container, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import ShowIf from 'funnel-schedule/ShowIf';
import useExitIntent from 'utils/useExitIntent';

export default function ModalExitSales({...props}) {
  const {isOpen, toggle} = useExitIntent(30000);

  return (
    <Modal className="modal-exit-intent" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center m-0">
        <Col xs="12" className="order-lg-2 py-5 my-auto">
          <h1 className="text-condensed text-800">Don’t miss out!</h1>

          <Row className="d-flex justify-content-center mb-4">
            <Col xs="12" sm="10" md="8" xl="6">
              <img className="img-fluid" src="https://cdn.foodrevolution.org/tntg/tntg-productimage-digitalall.png" />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col xs="12" sm="10" md="9" lg="10" xl="8">
              <h5 className="text-condensed text-800">
                The Impact Kit will help you change minds and make the world a better place for yourself and your loved
                ones.
              </h5>
              <ShowIf phase="replay" context="webinar">
                <p className="mb-0">
                  And now, for a <strong>limited time,</strong> you can support our mission and own this essential
                  collection of expertly curated resources. <strong>But your 50% discount expires soon.</strong>
                </p>
              </ShowIf>
            </Col>
          </Row>

          <Row className="d-flex justify-content-center wrapper pb-0">
            <Col xs="12" sm="10" lg="9" xl="7">
              <Button
                className="btn-block text-uppercase text-white text-condensed text-800 text-h4"
                color="cta"
                onClick={toggle}
              >
                Learn More
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Modal>
  );
}
